import { Notification } from 'element-ui'
import { isVNode } from 'element-ui/src/utils/vdom'

const MESSAGE_CLASS = 'jl-global-message'

function normalizeOptions(options) {
  if (typeof options === 'string' || isVNode(options)) return { message: options }
  return Object.assign({}, options || {})
}

function appendClass(current, extra) {
  return [current, extra].filter(Boolean).join(' ')
}

/**
 * 将原有 Message API 映射为右下角 Notification，彻底避开多级顶部导航。
 * 调用方仍可继续使用 this.$message、Message.success 等原有写法。
 */
function GlobalMessage(options) {
  const normalized = normalizeOptions(options)
  return Notification(Object.assign({}, normalized, {
    title: '',
    position: 'bottom-right',
    duration: normalized.duration === undefined ? 3000 : normalized.duration,
    showClose: normalized.showClose === true,
    customClass: appendClass(normalized.customClass, MESSAGE_CLASS)
  }))
}

function GlobalNotification(options) {
  const normalized = normalizeOptions(options)
  if (!normalized.position) normalized.position = 'bottom-right'
  return Notification(normalized)
}

;['success', 'warning', 'info', 'error'].forEach(type => {
  GlobalMessage[type] = options => GlobalMessage(Object.assign(
    normalizeOptions(options),
    { type }
  ))
  GlobalNotification[type] = options => GlobalNotification(Object.assign(
    normalizeOptions(options),
    { type }
  ))
})

GlobalMessage.closeAll = Notification.closeAll
GlobalNotification.closeAll = Notification.closeAll

export { GlobalMessage, GlobalNotification }
export default GlobalMessage



// WEBPACK FOOTER //
// ./src/utils/globalFeedback.js